const PANEL_ID = 'bdl-shell-recovery';

/**
 * Last resort when an exception destroys the root view during login and neither
 * the shell nor the login card is on screen. The in-app panel is preferred
 * while AppComponent is still alive.
 */
export function showBlankShellRecovery(
  documentRef: Document = document,
  reload: () => void = () => window.location.reload(),
): boolean {
  if (documentRef.getElementById(PANEL_ID)) return false;
  if (documentRef.querySelector('.ds-header, .login-card, .ds-shell-error, .ds-loading-overlay')) {
    return false;
  }

  const panel = documentRef.createElement('div');
  panel.id = PANEL_ID;
  panel.className = 'ds-shell-error';
  panel.setAttribute('role', 'alert');
  panel.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:100001',
    'background:#fff',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'padding:24px',
    'box-sizing:border-box',
    'font-family:Arial,sans-serif',
  ].join(';');

  const box = documentRef.createElement('div');
  box.style.cssText = 'max-width:420px;text-align:center';

  const title = documentRef.createElement('h2');
  title.textContent = 'No se pudo abrir BDL';
  title.style.margin = '0 0 8px';

  const text = documentRef.createElement('p');
  text.textContent = 'El inicio de sesión no llegó a mostrar la aplicación. Recargá la página para reintentar.';
  text.style.color = '#475569';

  const button = documentRef.createElement('button');
  button.type = 'button';
  button.textContent = 'Recargar';
  button.style.cssText = 'margin-top:8px;padding:8px 16px;cursor:pointer';
  button.addEventListener('click', () => reload());

  box.append(title, text, button);
  panel.append(box);
  (documentRef.body ?? documentRef.documentElement).append(panel);
  return true;
}
